<template>
  <b-navbar toggleable="lg" type="dark" class="bg-site-primary">
    <b-button
      class="mr-auto"
      :disabled="isFocused"
      @click="emitClick"
      :variant="isFocused ? 'secondary' : 'primary'"
    >Change Test</b-button>

    <h5 class="nav navbar-nav text-white text-center font-weight-bold" v-html="title"></h5>

    <b-modal id="submit-all-modal" hide-footer>
      <template v-slot:modal-title>Confirmation</template>
      <div
        v-if="isFocused"
        class="d-block text-center"
      >Once you submit your answers, you will not be able to retake the test.</div>
      <div
        v-else
        class="d-block text-center"
      >Once you submit your answers, you will not be able to retake the test. <br>
      <br>
      Please ensure you have <b>answered all tests</b> before submitting.</div>
      <b-button class="mt-3 bg-site-primary" block @click="submitAnswers">Submit My Answers</b-button>
      <b-button class="mt-1" block @click="$bvModal.hide('submit-all-modal')">Cancel</b-button>
    </b-modal>

    <b-navbar-nav class="ml-auto">
      <!-- <b-button v-if="isFocused" @click="$bvModal.show('submit-all-modal')" variant="primary" class="mr-2">Submit</b-button> -->
      <b-button v-if="!isFocused" @click="$bvModal.show('submit-all-modal')" variant="primary" class="mr-2">Submit All</b-button>
      <b-button @click="logout" variant="secondary"  :disabled="isFocused">Logout</b-button>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
export default {
  props: {
    title: String,
    mode: String,
  },
  computed: {
    isFocused(){
      return this.mode == "focused"
    }
  },
  methods: {
    emitClick() {
      this.$emit(`emitClick`);
    },
    logout() {
      const username = this.name;
      this.$store
        .dispatch(`user/logout`, { username })
        .then(() => {
          this.$router.push("/login");
        })
        .catch((err) => {
          this.loginError = err.message
          this.$router.push("/login")
        });
    },
    submitAnswers() {
      if(this.isFocused){
        this.$bvModal.hide(`submit-all-modal`)
      }
      var isFinal = !this.isFocused
      this.$emit("submitAnswers", isFinal);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>